export default "__VITE_ASSET__Dez7cdnM__"